import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
  setQueryParams,
  sendRequest,
  selectItemsIds
} from 'mt-react-common/common/reducers/_list/reducer';
import { selectItemById } from 'mt-react-common/common/reducers/objectCollection/reducer';

import { selectRequestStatusData } from 'mt-react-common/common/reducers/_requestStatus/reducer';
import { selectPaginationData } from 'mt-react-common/common/reducers/_pagination/reducer';
import { selectUserId } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import qs from 'querystring';

import PaginationBlock from '../../Common/Pagination/PaginationBlock/index';

import MediumPreLoader from '../../Common/PreLoaders/MediumPreLoader';
import TaskItem from './TaskItem';

const tasksCollectionRN = 'tasksModule.collections.tasksCollection';

class TasksList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      queryParams: {
        page: 1
      },
      queryParamsStatic: {
        user_id: this.props.userId
      }
    };
    this.sendRequest();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.location !== prevProps.location &&
      this.props.location.pathname === prevProps.location.pathname &&
      this.props.location.hash === prevProps.location.hash
    ) {
      this.sendRequest();
    }
  }

  setQueryParams = queryParams => {
    this.state.queryParams = { ...this.state.queryParams, ...queryParams };
    this.props.setQueryParams({
      ...this.state.queryParams,
      ...this.state.queryParamsStatic
    });
  };

  updateHistory = () => {
    this.context.router.history.push({
      pathname: this.props.location.pathname,
      search: `?${qs.stringify(this.state.queryParams)}`
    });
  };

  sendRequest = () => {
    this.setQueryParams(qs.parse(this.props.location.search.slice(1)));
    this.props.sendRequest();
  };

  render() {
    let comments = null;
    if (this.props.requestStatusData.requestInProcess) {
      comments = <MediumPreLoader />;
    } else if (this.props.itemsIds.length > 0) {
      comments = (
        <React.Fragment>
          {this.props.itemsIds.map(itemId => (
            // eslint-disable-next-line react/no-array-index-key
            <TaskItem
              key={`taskItem${itemId}`}
              task={this.props.selectItemById(itemId)}
              reducerName={this.props.reducerName}
            />
          ))}
          <PaginationBlock
            paginationData={this.props.paginationData}
            handlePageClick={pageNumber => {
              this.setQueryParams({ page: pageNumber });
              this.updateHistory();
            }}
          />
        </React.Fragment>
      );
    } else {
      comments = (
        <div className="alert alert-default text-center">
          <p>У пользователя нет комментариев :-(</p>
        </div>
      );
    }

    return <React.Fragment>{comments}</React.Fragment>;
  }
}

TasksList.propTypes = {
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  reducerName: PropTypes.string.isRequired,

  setQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,
  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectItemById: PropTypes.func.isRequired,
  requestStatusData: PropTypes.shape({
    requestInProcess: PropTypes.bool.isRequired
  }).isRequired,
  paginationData: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired,

  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
    hash: PropTypes.string.isRequired
  }).isRequired
};

TasksList.contextTypes = {
  router: PropTypes.shape()
};

const mapStateToProps = (state, props) => ({
  requestStatusData: selectRequestStatusData(props.reducerName, state),
  paginationData: selectPaginationData(props.reducerName, state),
  itemsIds: selectItemsIds(state, props.reducerName),
  selectItemById: id => selectItemById(state, tasksCollectionRN, id),
  authUserId: selectUserId(state)
});

const mapDispatchToProps = (dispatch, props) => ({
  setQueryParams: queryParams =>
    dispatch(setQueryParams(props.reducerName, queryParams)),
  sendRequest: () => dispatch(sendRequest(props.reducerName))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TasksList)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksList/TasksList.js